var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatiment3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "batiment_3",
    "data-name": "batiment 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2240.5 2151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c4b8b7;}.cls-2{fill:#e2dcdc;}.cls-3,.cls-5{fill:#a59797;}.cls-4,.cls-8{fill:#d6cece;}.cls-5,.cls-8{opacity:0.35;}.cls-6{fill:#d5d1db;}.cls-6,.cls-7{stroke:#4c4b54;stroke-miterlimit:10;stroke-width:7px;}.cls-7{fill:#b1aaba;}.cls-9{fill:#4c4b54;}.cls-10{fill:#e62e45;}.cls-11{fill:#b53041;}.cls-12{fill:#d71e3a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "batiment 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.5 1634 895.5 2151 2240.5 1377 2240.5 515 1342.5 0 0.5 772 0.5 1634"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "522.49 1935.53 522.5 822 898.5 599 1270.5 816 1270.5 1935.53 896.5 2151 522.49 1935.53"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.5 772 522.5 1075 522.5 1936 0.5 1634 0.5 772"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "522.5 822 896.5 1033 896.5 2151 522.5 1936 522.5 822"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2240.5 515 1270.5 1075.5 1270.5 1936 2240.5 1375 2240.5 515"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1493.5 946.64 1569.5 901 1569.5 1763.14 1493.5 1807.03 1493.5 946.64"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "302.5 946.64 226.5 901 226.5 1763.14 302.5 1807.03 302.5 946.64"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1717.5 816.64 1793.5 771 1793.5 1633.14 1717.5 1677.03 1717.5 816.64"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1939.5 689.64 2015.5 644 2015.5 1506.14 1939.5 1550.03 1939.5 689.64"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1345.5 1115 1493.5 1030 1493.5 1207 1345.5 1287 1345.5 1115"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1345.5 1375 1493.5 1290 1493.5 1467 1345.5 1547 1345.5 1375"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1345.5 1632 1493.5 1547 1493.5 1724 1345.5 1804 1345.5 1632"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1569.5 988 1717.5 903 1717.5 1080 1569.5 1160 1569.5 988"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1569.5 1248 1717.5 1163 1717.5 1340 1569.5 1420 1569.5 1248"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1569.5 1505 1940 1291 1939 1550 1568.5 1759 1569.5 1505"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1791.5 856 1939.5 771 1939.5 948 1791.5 1028 1791.5 856"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1791.5 1116 1939.5 1031 1939.5 1208 1791.5 1288 1791.5 1116"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "451.5 1118 303.5 1033 303.5 1210 451.5 1290 451.5 1118"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "451.5 1378 303.5 1293 303.5 1470 451.5 1550 451.5 1378"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "451.5 1635 303.5 1550 303.5 1727 451.5 1807 451.5 1635"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "226.5 990 78.5 905 78.5 1082 226.5 1162 226.5 990"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "226.5 1250 78.5 1165 78.5 1342 226.5 1422 226.5 1250"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "226.5 1507 78.5 1422 78.5 1599 226.5 1679 226.5 1507"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2015.5 729 2163.5 644 2163.5 821 2015.5 901 2015.5 729"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2015.5 989 2163.5 904 2163.5 1081 2015.5 1161 2015.5 989"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2015.5 1246 2163.5 1161 2163.5 1338 2015.5 1418 2015.5 1246"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "896.5 1033 1270.5 822 1270.5 1936 896.5 2151 896.5 1033"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "522.5 1086.42 0 785.5 0 771.5 522.5 1075 522.5 1086.42"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1270.5 1075.5 2240.5 515 2240.5 526 1270.5 1086.42 1270.5 1075.5"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "522 986.5 153 772.5 1345 85.5 2089 515.5 1270 986.5 522 986.5"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "522.49 985.62 896.49 1204.61 1270.5 985.62 1270.5 816 896.5 599 522.5 822 522.49 985.62"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "522.5 822 896.5 1033 896.5 1205 522.5 986 522.5 822"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "896.5 1205 896.5 1033 1270.5 816 1270.5 986 896.5 1205"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "596.5 1119 675.5 1165 675.5 1422 596.5 1375 596.5 1119"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "747 1203 826 1249 826 1506 747 1459 747 1203"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "596.5 1462 675.5 1508 675.5 1681 596.5 1634 596.5 1462"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "597 1721 676 1767 676 1940 597 1893 597 1721"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "747 1546 826 1592 826 1765 747 1718 747 1546"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "747 1805 826 1851 826 2024 747 1977 747 1805"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1200 1119 1121 1165 1121 1422 1200 1375 1200 1119"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1049.5 1203 970.5 1249 970.5 1506 1049.5 1459 1049.5 1203"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1200 1462 1121 1508 1121 1681 1200 1634 1200 1462"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1199.5 1721 1120.5 1767 1120.5 1940 1199.5 1893 1199.5 1721"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1049.5 1546 970.5 1592 970.5 1765 1049.5 1718 1049.5 1546"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1049.5 1805 970.5 1851 970.5 2024 1049.5 1977 1049.5 1805"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatiment3);
export default __webpack_public_path__ + "static/media/batiment_3.37f3d2fea82c5bafdda5c25c2ab3c155.svg";
export { ForwardRef as ReactComponent };